import { DEFAULT_SERVER_URL, PUBLIC_SERVER_URL } from "@hub/shared";

const LOCAL_HOST = /^(localhost|127\.0\.0\.1|\[::1\])$/i;

/** Development builds (vite dev, vitest, the desktop dev run) may point at any server; release builds use one. */
export const SERVER_URL_EDITABLE: boolean = import.meta.env.DEV;

/**
 * Where the API lives: the page's own origin when the web app is served by the Hub server; otherwise the public
 * server in a release build (the packaged Mac app, the extension), and the development server while developing.
 */
export function defaultServerUrl(location: { protocol: string; hostname: string; origin: string } | null = typeof window !== "undefined" ? window.location : null): string {
  if (location && /^https?:$/.test(location.protocol) && !LOCAL_HOST.test(location.hostname)) return location.origin;
  return SERVER_URL_EDITABLE ? DEFAULT_SERVER_URL : PUBLIC_SERVER_URL;
}
